export const GRAPH_URL: string =
    'https://api-ca-central-1.graphcms.com/v2/ckuzjviat02xr01xl11hb0tx0/master';
